module.exports = __webpack_public_path__ + "static/media/png.a82b748e.png";